/**
 * DIEUKYDIEU.TV - SEARCH API SERVICE
 * Connects UI to backend search endpoint with mock / client-side search fallback.
 * Under 300 lines rule compliant.
 */

import { API_CONFIG } from './config.js';
import { apiClient } from './client.js';
import { mockAdapter } from './mock/mock-adapter.js';

export const searchApi = {
    /**
     * Search articles by query with optional filters
     * @param {string} query 
     * @param {{ category?: string, page?: number, limit?: number }} [options] 
     */
    async searchArticles(query, options = {}) {
        if (!query || !query.trim()) {
            return { items: [], total: 0 };
        }

        if (API_CONFIG.USE_MOCK) {
            const res = await mockAdapter.searchArticles(query, options);
            return res.data;
        }

        try {
            const res = await apiClient.get('/search', {
                q: query.trim(),
                category: options.category || 'all',
                page: options.page || 1,
                limit: options.limit || 20
            });
            return res.data || res;
        } catch (err) {
            console.warn('[searchApi] Remote search failed, falling back to mock client-side search:', err.message);
            if (API_CONFIG.ENABLE_FALLBACK_ON_ERROR) {
                const fallbackRes = await mockAdapter.searchArticles(query, options);
                return fallbackRes.data;
            }
            throw err;
        }
    }
};
